import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["back"];

  connect() {
    // Initialize with header hidden above viewport
    this.backTarget.style.transform = 'translateY(-100%)';
    this.backTarget.style.transition = 'transform 0.3s ease-in-out';

    window.addEventListener("scroll", this.toggleBackVisibility);
  }

  disconnect() {
    window.removeEventListener("scroll", this.toggleBackVisibility);
  }

  toggleBackVisibility = () => {
    const scrollThreshold = 200;

    if (window.scrollY >= scrollThreshold) {
      this.backTarget.style.transform = 'translateY(0)';
    } else {
      this.backTarget.style.transform = 'translateY(-100%)';
    }
  };
}